import React from 'react'

const CategoryFilter = ({ categories, active, handleClick }) => {
  return (
    <div className="mb-2 buttons--container">
      <button
        value="All"
        className={
          'All' === active
            ? 'button primary-dark'
            : 'button hollow primary-dark'
        }
        onClick={handleClick}
      >
        Tout
      </button>
      <button
        value="Promos"
        className={
          'Promos' === active
            ? 'button primary-light'
            : 'button hollow primary-light'
        }
        onClick={handleClick}
      >
        Promos
      </button>
      {categories.map(category => {
        return (
          <button
            key={category.name}
            value={category.name}
            className={
              category.name === active
                ? 'button primary-dark'
                : 'button hollow primary-dark'
            }
            onClick={handleClick}
          >
            {category.name}
          </button>
        )
      })}
    </div>
  )
}

export default CategoryFilter
